// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientUpsearchModel {
    static getAttributeTypeMap() {
        return PatientUpsearchModel.attributeTypeMap;
    }
}
PatientUpsearchModel.discriminator = undefined;
PatientUpsearchModel.additionalProperties = false;
PatientUpsearchModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "socialSecurityNumber",
        "baseName": "socialSecurityNumber",
        "type": "string"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "isDuplicate",
        "baseName": "isDuplicate",
        "type": "boolean"
    },
    {
        "name": "isTest",
        "baseName": "isTest",
        "type": "boolean"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "nickname",
        "baseName": "nickname",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "primaryLanguageId",
        "baseName": "primaryLanguageId",
        "type": "number"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "isUsResident",
        "baseName": "isUsResident",
        "type": "boolean"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "masterPatientId",
        "baseName": "masterPatientId",
        "type": "string"
    },
    {
        "name": "raceCode",
        "baseName": "raceCode",
        "type": "string"
    },
    {
        "name": "ethnicityCode",
        "baseName": "ethnicityCode",
        "type": "string"
    },
    {
        "name": "unsecureMasterPatientId",
        "baseName": "unsecureMasterPatientId",
        "type": "number"
    },
];
//# sourceMappingURL=patientUpsearchModel.js.map